import React, { useState, useEffect, useContext } from "react";
import { StoreContext } from "../../store/Store";
import { GlobalRefContext } from "../../store/GlobalRefs";
import { saveDocToS3 } from "../../api/s3";
import { arrayBufferToBase64, Choose, Detail, Display, Upload } from "./utils";
import { editAudit } from "../custom/audit";
const SingleFileUploader = ({ data }) => {
  const [store] = useContext(StoreContext);
  const grefs = useContext(GlobalRefContext);
  const { auth } = store;
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState("initial");
  const [showDetail, setShowDetail] = useState(false);

  useEffect(() => {
    const me = grefs.auditTrail.current.find((node) => {
      return node.nodeId === data.id;
    });

    if (me && me.filename) {
      setFile(me.file);
      if (me.uploaded) {
        setStatus("success");
      }
    }
  }, [grefs.auditTrail, data]);

  const handleFileChange = (e) => {
    if (e.target.files) {
      editAudit(grefs, data.id, e.target.files[0]);
      setStatus("initial");
      setFile(e.target.files[0]);
    }
  };

  const handleUpload = async () => {
    if (file) {
      if (file.uploaded) {
        alert("this file has already been uploaded");
      } else {
        setStatus("uploading");
        const reader = new window.FileReader();
        reader.readAsArrayBuffer(file);
        reader.onloadend = () => {
          const image = arrayBufferToBase64(reader.result);
          const payload = {
            name: file.name,
            folder: auth.tempCurrentUser.username + "/" + data.id,
            image: image,
          };
          const asyncfunction = async () => {
            const result = await saveDocToS3(auth, payload);
            if (result.statusCode && result.statusCode === 201) {
              editAudit(grefs, data.id, null, result.body);
              setStatus("success");
            } else {
              console.log("result", result);
              setStatus("fail");
            }
          };
          asyncfunction();
        };
      }
    }
  };

  return data.type === "screenshot" ? (
    <div style={{ display: "flex", marginTop: 10 }}>
      <Choose data={data} handleFileChange={handleFileChange} />
      <Detail
        file={file}
        style={data.style.detailStyle}
        showDetail={showDetail}
      />
      <Display
        file={file}
        style={data.style.displayStyle}
        setShowDetail={setShowDetail}
      />
      <Upload
        file={file}
        style={data.style.labelStyle}
        status={status}
        handleUpload={handleUpload}
      />
    </div>
  ) : null;
};

export default SingleFileUploader;
